<template>
	<div class="c-block-view-copy" @click="onCopy">
		<Float ref="float"></Float>
		<slot>
			<svg
				width="16"
				height="16"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M8 8V7.2C8 6.0799 8 5.51984 8.21799 5.09202C8.40973 4.71569 8.71569 4.40973 9.09202 4.21799C9.51984 4 10.0799 4 11.2 4H16.8C17.9201 4 18.4802 4 18.908 4.21799C19.2843 4.40973 19.5903 4.71569 19.782 5.09202C20 5.51984 20 6.0799 20 7.2V12.8C20 13.9201 20 14.4802 19.782 14.908C19.5903 15.2843 19.2843 15.5903 18.908 15.782C18.4802 16 17.9201 16 16.8 16H16M16 11.2V16.8C16 17.9201 16 18.4802 15.782 18.908C15.5903 19.2843 15.2843 19.5903 14.908 19.782C14.4802 20 13.9201 20 12.8 20H7.2C6.0799 20 5.51984 20 5.09202 19.782C4.71569 19.5903 4.40973 19.2843 4.21799 18.908C4 18.4802 4 17.9201 4 16.8V11.2C4 10.0799 4 9.51984 4.21799 9.09202C4.40973 8.71569 4.71569 8.40973 5.09202 8.21799C5.51984 8 6.0799 8 7.2 8H12.8C13.9201 8 14.4802 8 14.908 8.21799C15.2843 8.40973 15.5903 8.71569 15.782 9.09202C16 9.51984 16 10.0799 16 11.2Z"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
				/>
			</svg>
		</slot>
	</div>
</template>

<script>
import Float from './float';

export default {
	components: {
		Float,
	},

	data: function () {
		return {
			processing: false,
		};
	},

	props: {
		text: {
			default: '',
		},
	},

	computed: {
		copyText: function () {
			return 'Copied!';
		},
	},

	methods: {
		onCopy: function () {
			this.processing = true;
			let text = this.text;

			// Copy the text inside the text field
			navigator.clipboard.writeText(text);

			this.$refs.float.addFloat();

			setTimeout(() => {
				this.processing = false;
			}, 1500);
		},
	},
};
</script>

<style lang="scss">
.c-block-view-copy {
	position: relative;
	cursor: pointer;
	opacity: 0.8;

	&:hover,
	&:active {
		opacity: 1;
		color: var(--color-primary);
	}
}
</style>
